module.exports = __webpack_public_path__ + "img/mb1t0.34f28c0f.png";